import React, { useEffect, useState } from "react";
import { PatternlibDatepicker } from "@liebherr/patternlib-react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

const FormDatepicker = ({
  label,
  placeholder,
  name,
  initialValue,
  onChange,
  error,
  additionalInfo,
}) => {
  const [value, setValue] = useState(initialValue);
  const onDate = () => {
    const current = new Date();
    const currentYear = current.getFullYear();
    const currentMonth = current.getMonth() + 1;
    const currentDay = current.getDate();
    const currentDate =
      currentYear + "/" + currentMonth + "/" + currentDay + " " + "00:00";
    return currentDate;
  };
  const { t, i18n } = useTranslation();

  // Call function, when value has been changed
  useEffect(() => {
    if (value) {
      onChange(`${value}`);
    } else if (value === null) {
      onChange("");
    }
  }, [value]);

  const onChangeListener = (event) => {
    const value = event.detail.value;
    setValue(value);
  };

  return (
    <PatternlibDatepicker
      label={label}
      placeholder={placeholder}
      name={name}
      initial-date={initialValue}
      onLhChange={onChangeListener}
      error-text={error}
      status={error !== null ? "error" : "default"}
      additional-info={additionalInfo}
      show-apply-button="false"
      date-time-format={
        i18n.language === "de-DE" || i18n.language === "de" ? "de-DE" : "en-EN"
      }
      minimum-date={onDate()}
    ></PatternlibDatepicker>
  );
};

FormDatepicker.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  initialValue: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  additionalInfo: PropTypes.string,
};

FormDatepicker.defaultProps = {
  label: "Label",
  placeholder: "Placeholder text",
  error: null,
};

export default FormDatepicker;
